import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["label", "name", "checked", "error", "id", "onChange"];
var _jsxFileName = "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DLS-WEB-JOB1/src/components/Checkbox/CheckboxInput.js",
  _this = this;
import React, { useState, useLayoutEffect } from 'react';
import styled, { css } from 'styled-components';
import Text from '../Text';
import { noop } from '../../helpers';
import { withClearInteraction } from '../../helpers/styled';
import CheckboxTick from './tick.svg';
import { withTheme } from '../../core/ThemeProvider';
var CheckboxInput = function CheckboxInput(_ref) {
  var label = _ref.label,
    name = _ref.name,
    checked = _ref.checked,
    error = _ref.error,
    id = _ref.id,
    onChange = _ref.onChange,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(checked),
    _useState2 = _slicedToArray(_useState, 2),
    isChecked = _useState2[0],
    setCheckboxValue = _useState2[1];
  var handleClick = function handleClick(e) {
    setCheckboxValue(!isChecked);
    onChange(e, !isChecked);
  };
  useLayoutEffect(function () {
    setCheckboxValue(!!checked);
  }, [checked]);
  return /*#__PURE__*/React.createElement(CheckboxWrapper, {
    "data-testid": rest['data-testid'],
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 31,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement("input", _extends({}, rest, {
    name: name,
    id: id,
    type: "checkbox",
    checked: isChecked,
    onChange: onChange,
    "data-testid": "checkboxInputEl",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 32,
      columnNumber: 7
    }
  })), /*#__PURE__*/React.createElement(CheckboxContainer, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 43,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(Checkbox, {
    enableInteraction: true,
    onClick: handleClick,
    "data-testid": "checkbox-button",
    error: error,
    checked: isChecked,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 44,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(CheckboxTick, {
    viewBox: "0 0 16 11",
    width: 16,
    height: 16,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 54,
      columnNumber: 11
    }
  }))), /*#__PURE__*/React.createElement(LabelText, {
    type: "body",
    dangerouslySetInnerHTML: {
      __html: label
    },
    lineHeight: "compact",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 57,
      columnNumber: 7
    }
  }));
};
CheckboxInput.defaultProps = {
  checked: false,
  onChange: noop
};
export default CheckboxInput;
var CheckboxContainer = styled.div.withConfig({
  displayName: "CheckboxInput__CheckboxContainer",
  componentId: "sc-nk95e7-0"
})(["align-self:flex-start;"]);
export var CheckboxWrapper = styled.div.withConfig({
  displayName: "CheckboxInput__CheckboxWrapper",
  componentId: "sc-nk95e7-1"
})(["align-items:center;display:flex;justify-content:flex-start;input{position:absolute;left:-999999px;top:0;opacity:0;width:1px;height:1px;}label{display:none;}"]);
var LabelText = withTheme(styled(Text).withConfig({
  displayName: "CheckboxInput__LabelText",
  componentId: "sc-nk95e7-2"
})(["font-size:", ";padding-left:16px;a{color:", ";font-family:", ";text-decoration:none;}"], function (p) {
  return p.coreTheme.fs_xl;
}, function (p) {
  return p.coreTheme.cl_sec_d1;
}, function (p) {
  return p.coreTheme.ff_sec_bold;
}));
var Checkbox = withClearInteraction(withTheme(styled.div.withConfig({
  displayName: "CheckboxInput__Checkbox",
  componentId: "sc-nk95e7-3"
})(function (_ref2) {
  var checked = _ref2.checked,
    error = _ref2.error,
    coreTheme = _ref2.coreTheme;
  var showError = error && !checked;
  return css(["position:relative;flex-direction:row;justify-content:center;align-items:center;height:", "px;width:", "px;display:inline-flex;vertical-align:top;margin:0;line-height:0;border:1px solid ", ";border-radius:8px;background-color:", ";cursor:pointer;"], coreTheme.space_8, coreTheme.space_8, checkboxBorderColor(checked, showError, {
    checked: coreTheme.cl_sec_d1,
    error: coreTheme.cl_pri_d3,
    "default": coreTheme.cl_ter_l4
  }), checked ? coreTheme.cl_sec_d1 : coreTheme.cl_white);
})), 12);
var checkboxBorderColor = function checkboxBorderColor(checked, error, colors) {
  if (checked) {
    return colors.checked;
  } else if (error) {
    return colors.error;
  } else {
    return colors["default"];
  }
};